"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const CustomerDetail_1 = __importDefault(require("./CustomerDetail"));
function pricing(props) {
    const [pricingData, setPricingData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        getPricingData();
    }, [props]);
    const getPricingData = () => {
        const params = new URLSearchParams();
        params.append("brandId", props.brandId);
        params.append("selectedDate", props.selectedDate.toString());
        params.append("paxCount", props.paxCount.toString());
        params.append("duration", props.duration.toString());
        params.append("selectedTime", props.selectedTime);
        if (props.foodPackage)
            params.append("foodPackage", props.foodPackage);
        if (props.beveragePackage)
            params.append("beveragePackage", props.beveragePackage);
        const baseUrl = "/api/widget/pricing/" + props.uuid;
        axios_1.default
            .get(baseUrl, {
            params: params,
        })
            .then((response) => {
            console.log("pricing ajax", response.data);
            setPricingData(response.data);
        })
            .catch((error) => {
            setPricingData(null);
        });
    };
    console.log(props);
    return (react_1.default.createElement("div", { id: "pricing" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Pricing")),
                (pricingData == null) && (react_1.default.createElement(material_1.Typography, { variant: "body1" }, "Loading...")),
                pricingData && (react_1.default.createElement(react_1.default.Fragment, null,
                    pricingData.lineItems.map((lineItem) => (react_1.default.createElement(material_1.Grid, { item: true, key: lineItem.description, xs: 12, pt: 1 },
                        react_1.default.createElement(material_1.Stack, { direction: "row" },
                            react_1.default.createElement(material_1.Typography, { width: "50%", textAlign: "left", variant: "body1" }, lineItem.description),
                            lineItem.strike_through_amount && (react_1.default.createElement(material_1.Stack, { width: "100%" },
                                react_1.default.createElement(material_1.Typography, { textAlign: "right", variant: "body1", sx: { color: "red" } }, lineItem.amount),
                                react_1.default.createElement(material_1.Typography, { sx: { textDecoration: "line-through" }, textAlign: "right", variant: "body1" }, lineItem.strike_through_amount))),
                            !lineItem.strike_through_amount && (react_1.default.createElement(material_1.Typography, { width: "50%", textAlign: "right", variant: "body1" }, lineItem.amount)))))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Stack, { direction: "row", pt: 2 },
                            react_1.default.createElement(material_1.Typography, { width: "50%", textAlign: "left", variant: "h6" },
                                react_1.default.createElement("strong", null, "Total")),
                            (pricingData === null || pricingData === void 0 ? void 0 : pricingData.totalStrikeThrough) && (react_1.default.createElement(material_1.Stack, { width: "100%" },
                                react_1.default.createElement(material_1.Typography, { textAlign: "right", variant: "h6", sx: { color: "red" } },
                                    react_1.default.createElement("strong", null, pricingData === null || pricingData === void 0 ? void 0 : pricingData.total)),
                                react_1.default.createElement(material_1.Typography, { sx: { textDecoration: "line-through" }, textAlign: "right", variant: "body1" }, pricingData === null || pricingData === void 0 ? void 0 : pricingData.totalStrikeThrough))),
                            !(pricingData === null || pricingData === void 0 ? void 0 : pricingData.totalStrikeThrough) && (react_1.default.createElement(material_1.Typography, { width: "50%", textAlign: "right", variant: "h6" },
                                react_1.default.createElement("strong", null, pricingData === null || pricingData === void 0 ? void 0 : pricingData.total)))))))),
            (pricingData != null) && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(CustomerDetail_1.default, { uuid: props.uuid, brandId: props.brandId, selectedDate: props.selectedDate, paxCount: props.paxCount, duration: props.duration, selectedTime: props.selectedTime, foodPackage: props.foodPackage, beveragePackage: props.beveragePackage }))))));
}
exports.default = pricing;
